<template>
  <v-main>
    <v-app-bar app flat light color="white">
      <AppbarBackIcon />
      <v-toolbar-title class="font-weight-bold">支付渠道</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn v-if="!isCreate" icon color="red" @click="onDelete">
        <v-icon>{{ mdiDelete }}</v-icon>
      </v-btn>
    </v-app-bar>
    <v-container fluid>
      <v-row dense>
        <v-col>
          <v-text-field label="名称" hint="例如：微信支付" class="required" v-model="form.name" />
        </v-col>
        <v-col>
          <v-select
            right
            :readonly="!isCreate"
            :items="paymentChannelTypeList"
            v-model="form.type"
            :value="form.type"
          ></v-select>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col>
          <v-text-field label="备注" hint="后台备注，方便区分支付渠道" v-model="form.note" />
        </v-col>
      </v-row>
      <template v-if="PaymentChannelType.isHupijiao(form.type)">
        <HupijiaoForm v-model="form.config" />
      </template>
      <template v-if="form.type === PaymentChannelType.STANDARD_WEIXIN_V3">
        <WeixinV3Form v-model="form.config" />
      </template>
      <template v-if="form.type === PaymentChannelType.STANDARD_ALIPAY">
        <AlipayForm v-model="form.config" />
      </template>
      <template v-if="PaymentChannelType.isSimpleWeixinAlipay(form.type)">
        <QrcodeForm v-model="form.config" />
      </template>
      <template v-if="form.type === PaymentChannelType.SIMPLE_BITCOIN">
        <v-text-field label="钱包地址" class="required" v-model="form.config.wallet_address" />
      </template>
      <template v-if="form.type === PaymentChannelType.PAYPAL_ME">
        <v-text-field label="paypal.me/名称" class="required" v-model="form.config.link_name" />
      </template>
      <v-row>
        <v-col cols="4"
          ><v-btn width="100%" color="secondary" class="mt-8" @click="onHealthCheck">检查配置</v-btn></v-col
        >
        <v-col cols="8"><v-btn width="100%" color="primary" class="mt-8" @click="onSave">保存</v-btn></v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
import AppbarBackIcon from '@/components/AppbarBackIcon.vue'
import _ from 'lodash'
import { mdiDelete, mdiPlus } from '@mdi/js'
import { PaymentChannelType, paymentChannelTypeList } from '@/plugins/payment'
import { paymentChannelStore } from '@/store/paymentChannel'
import { homeStore } from '@/store/home'
import HupijiaoForm from '@/views/payment-channel/HupijiaoForm.vue'
import QrcodeForm from '@/views/payment-channel/QrcodeForm.vue'
import WeixinV3Form from '@/views/payment-channel/WeixinV3Form.vue'
import AlipayForm from './AlipayForm.vue'

export default {
  name: 'PaymentChannelDetailPage',
  components: {
    AppbarBackIcon,
    HupijiaoForm,
    QrcodeForm,
    WeixinV3Form,
    AlipayForm,
  },
  data() {
    return {
      mdiDelete,
      mdiPlus,
      paymentChannelTypeList,
      PaymentChannelType,
      form: {
        name: null,
        note: null,
        type: paymentChannelTypeList[0].value,
        config: {
          app_id: null,
          app_secret: null,
          api_url: null,
          website_url: null,
          website_name: null,
          auth_type: 'K',
          sign_type: 'RSA2',
          app_private_key: null,
          app_public_key_cert: null,
          alipay_public_key: null,
          alipay_public_key_cert: null,
          alipay_root_cert: null,
          is_support_pc: false,
          is_support_jsapi: false,
          is_support_h5: false,
          is_support_app: false,
          is_support_code: false,
          wallet_address: null,
          link_name: null,
          dynamic_qrcode_key: null,
          dynamic_qrcode_value: null,
          static_qrcode_list: [],
        },
      },
    }
  },
  computed: {
    id() {
      return this.$route.query.id || null
    },
    isCreate() {
      return _.isNil(this.id)
    },
    paymentChannel() {
      return paymentChannelStore.get(this.id)
    },
  },
  async mounted() {
    await homeStore.doLoad()
    if (!this.isCreate) {
      this.syncForm()
    }
  },
  methods: {
    syncForm() {
      if (!_.isNil(this.paymentChannel)) {
        this.form.name = this.paymentChannel.name
        this.form.note = this.paymentChannel.note
        this.form.type = this.paymentChannel.type
        this.form.config = this.paymentChannel.config
      }
    },
    getFormPayload() {
      let config = { ...this.form.config }
      if (PaymentChannelType.isSimpleWeixinAlipay(this.form.type)) {
        if (!config.dynamic_qrcode_key || !config.dynamic_qrcode_value) {
          this.dynamic_qrcode_error = '请上传不定额收款码'
          return
        }
      }
      if (config.static_qrcode_list) {
        config.static_qrcode_list = config.static_qrcode_list.filter(x => {
          return x.qrcode_key && x.qrcode_value
        })
      }
      if (!this.form.name) {
        return
      }
      return {
        name: this.form.name,
        note: this.form.note,
        type: _.parseInt(this.form.type),
        config: config,
      }
    },
    async onHealthCheck() {
      let payload = this.getFormPayload()
      if (_.isNil(payload)) {
        return
      }
      let result = await paymentChannelStore.doHealthCheck({ ...payload })
      if (result.is_ok) {
        this.$toasted.success('配置正确，可正常使用')
        return
      }
      let detail = JSON.stringify(result.detail, null, 2)
      detail = result.message + '\n' + detail
      await this.$dialog.warning({
        title: '配置存在问题',
        text: detail,
        actions: [
          {
            text: '好的',
            color: 'blue',
            key: true,
          },
        ],
      })
    },
    async onSave() {
      let payload = this.getFormPayload()
      if (_.isNil(payload)) {
        return
      }
      if (this.isCreate) {
        let channel = await paymentChannelStore.doCreate({ ...payload })
        this.$router.replace({ query: { id: channel.id } })
      } else {
        await paymentChannelStore.doUpdate({ id: this.id, ...payload })
      }
      this.$toasted.success('保存成功')
      this.syncForm()
    },
    async onDelete() {
      const msg = `确定要删除支付渠道「${this.paymentChannel.name}」吗`
      if (!(await this.$dialog.confirm({ text: msg }))) {
        return
      }
      await paymentChannelStore.doDelete(this.id)
      this.$toasted.success('删除成功')
      this.$router.back()
    },
  },
}
</script>

<style lang="less" scoped>
.notify-url {
  word-break: break-all;
}
</style>
